<template>
    <v-container class="features-background pt-5" style="max-width: 1300px;">
        <v-layout row wrap class="my-5 pb-5">
            <v-flex xs12 md6 class="text-xs-center">
                <img src="https://vorsi-home.s3.amazonaws.com/images/Accounts-Receivable-Screenshot.png"
                     alt="" style="margin: 0 auto; height: auto; width: 80%">
            </v-flex>
            <v-flex xs12 md6 style="text-align: left">
                <div class="overview-icons--text2 pt-5 mt-5">
                    Manage all of your invoices and payments from one dashboard. <br>
                    Setup Client Auto-Bill-Pay via Credit Card or ACH and have all your invoices paid automatically.
                </div>
                <div class="mt-5">
                    <v-layout class="schedule-a-demo-layout">
                        <v-btn color="primary" @click="changeLocation('/contact-us')">Contact Us
                        </v-btn>
                    </v-layout>
                </div>
            </v-flex>
        </v-layout>
        <v-layout row wrap class="md-and-up-padding-top">
            <v-flex xs12 md6 style="text-align: left">
                <div class="indigo--text overview-icons--text pt-5">
                    <b>Manage all of your clients, orders and production from one dashboard.</b>
                </div>
                <div class="overview-icons--text2 pt-5">
                    Scale your ordering capabilities as your company grows. <br>
                    Improve communication and order accuracy with your clients to build confident,
                    lasting relationships.
                </div>
            </v-flex>
            <v-flex xs12 md6 class="text-xs-center sm-image-top-padding">
                <img src="https://vorsi-home.s3.amazonaws.com/images/CRM-Datatable-Screenshot.png"
                     alt="" style="margin: 0 auto; height: auto; width: 80%">
            </v-flex>
        </v-layout>
        <v-layout row wrap justify-center class="mt-5 pt-5">
            <v-flex xs12 md6>
                <v-layout row wrap justify-center>
                    <icon-base
                            viewBox="0 0 604.362 682.465"
                            width="450"
                            height="100%"
                    >
                        <icon-salesOrderingFlowDiagram/>
                    </icon-base>
                </v-layout>
            </v-flex>
            <v-flex xs12 md6>
                <v-layout row wrap justify-center class="pt-5">
                    <v-flex xs12 class="deep-purple--text text--darken-3 overview-headline text-xs-center"
                            style="font-weight: 900">
                        Advanced User Management
                    </v-flex>
                    <v-flex xs12 class="overview-subheadline text-xs-center">
                        Robust tools designed to manage small businesses to large organizations.
                    </v-flex>
                    <v-flex xs12 class="pa-4">
                        <v-layout row wrap justify-center>
                            <v-flex xs2 class="px-5">
                                <v-layout row wrap justify-center>
                                    <v-icon class="features-icons" color="accent" large>mdi-account-supervisor-circle</v-icon>
                                </v-layout>
                            </v-flex>
                            <v-flex grow class="text-xs-center text-md-left">
                                <div class="overview-icons--text"><b>Client Ownership</b></div>
                                <div class="overview-icons--text2">Assign ownership of your
                                    clients to your users.
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs12 class="pa-4">
                        <v-layout row wrap justify-center>
                            <v-flex xs2>
                                <v-layout row wrap justify-center>
                                    <icon-base
                                            style="color: #1976D2; margin-top:-8px;"
                                            icon-color="#1976D2"
                                            viewbox="0 0 625.369 496"
                                            width="45"
                                            height="45"
                                    >
                                        <icon-treeDiagram/>
                                    </icon-base>
                                </v-layout>
                            </v-flex>
                            <v-flex grow class="text-xs-center text-md-left">
                                <div class="overview-icons--text"><b>Employee Management
                                    Tree</b></div>
                                <div class="overview-icons--text2">Designate users to different
                                    levels of management.
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs12 class="pa-4">
                        <v-layout row wrap justify-center>
                            <v-flex xs2 class="px-5">
                                <v-layout row wrap justify-center>
                                    <v-icon class="features-icons" color="accent" large>mdi-account-group</v-icon>
                                </v-layout>
                            </v-flex>
                            <v-flex grow class="text-xs-center text-md-left">
                                <div class="overview-icons--text"><b>User Groups</b></div>
                                <div class="overview-icons--text2">Create groups for user
                                    management.
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import IconBase from '../../components/icons/IconBase.vue'
    import IconTreeDiagram from '../../components/icons/IconTreeDiagram.vue'
    import IconSalesOrderingFlowDiagram from '../../components/icons/IconSalesOrderingFlowDiagram.vue'

    export default {
        components: {
            IconBase,
            IconTreeDiagram,
            IconSalesOrderingFlowDiagram,
        },
        methods: {
            changeLocation(route) {
                window.location = route
            },
        }
    }
</script>

<style scoped>

</style>
